var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 436,
    height: 25,
    viewBox: "0 0 436 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.21068C0 2.36834 2.36633 0.0976924 5.20625 0.214937L432.575 17.8586C434.489 17.9376 436 19.5122 436 21.4278C436 23.4007 434.401 25 432.428 25H4.99999C2.23857 25 0 22.7614 0 20V5.21068Z",
    fill: "#EDF0F5"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRange);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDM2IiBoZWlnaHQ9IjI1IiB2aWV3Qm94PSIwIDAgNDM2IDI1IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMCA1LjIxMDY4QzAgMi4zNjgzNCAyLjM2NjMzIDAuMDk3NjkyNCA1LjIwNjI1IDAuMjE0OTM3TDQzMi41NzUgMTcuODU4NkM0MzQuNDg5IDE3LjkzNzYgNDM2IDE5LjUxMjIgNDM2IDIxLjQyNzhDNDM2IDIzLjQwMDcgNDM0LjQwMSAyNSA0MzIuNDI4IDI1SDQuOTk5OTlDMi4yMzg1NyAyNSAwIDIyLjc2MTQgMCAyMFY1LjIxMDY4WiIgZmlsbD0iI0VERjBGNSIvPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };